<template>
  <div class="vx-row mb-6">
    <div class="vx-col sm:w-1/4 w-full flex items-center">
      <span>Territory</span>
    </div>
    <div class="vx-col sm:w-3/4 w-full">
      <multiselect
        v-model="selected"
        :options="options"
        placeholder="Type to search"
        track-by="name"
        label="name"
        :allow-empty="true"
      >
        <span slot="noResult">Oops! No data found</span>
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <span class="option__title"
              >{{ props.option.code }} {{ props.option.name }}</span
            >
          </span>
        </template>

        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title"
              >{{ props.option.code }} {{ props.option.name }}</span
            >
          </div>
        </template>
      </multiselect>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseUrl: "/api/sfa/v1/territory/operating-unit-territories",
      options: [],
      selected: null,
    };
  },
  methods: {
    getData(params) {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: params,
        })
        .then((resp) => {
          if (resp.code == 200) {
            var options = [];
            resp.data.records.forEach(function (item) {
              options.push(item);
            }, options);
            this.options = options;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    reset() {
      this.selected = null;
      this.options = [];
    },
  },
  watch: {
    selected(v) {
      this.selected = v;
      this.$emit("data", v.territory_id, v.code);
    },
  },
};
</script>
